import {CopilotWidgetType} from 'common/src/modules/shared/copilot/copilot.enums';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {RelatedCardType} from 'common/src/modules/excelToCampaign/excelToCampaign.enums';
import {z} from 'zod';
import {ExcelToCampaignAgentToolName} from './excelImport.enums';
import tabularDataToCsv from 'common/src/modules/shared/copilot/csvUtils/tabularDataToCsv';

const inputSchema = z.object({
  mappingSummary: z
    .array(
      z.object({
        header: z.string().describe('The Excel header name'),
        cardType: z.nativeEnum(RelatedCardType).describe('The card type this header maps to'),
        signal: z
          .object({
            name: z.string(),
            key: z.string(),
          })
          .nullable()
          .optional()
          .describe('The signal details — only relevant for Condition card type'),
      }),
    )
    .describe('Summary of which Excel header was mapped to which card type'),
});

function showExcelImportSummaryTool() {
  async function execute({
    toolUtils: {showMessage},
    input: {mappingSummary},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    showMessage({
      type: CopilotWidgetType.ExcelToCampaignSummary,
      content: mappingSummary,
    });

    return toolResult(`Import summary shown to user. \n ${tabularDataToCsv(mappingSummary)}`);
  }

  return tool({
    name: ExcelToCampaignAgentToolName.ShowExcelImportSummary,
    displayName: 'Showing import summary',
    description:
      'Shows a visual summary table of which Excel headers were mapped to which campaign card types. Call this after the campaign tree is successfully created.',
    execute,
    inputSchema,
  });
}

export default showExcelImportSummaryTool;
